import { render } from "./ModalApprovalEmployeeOrders.vue?vue&type=template&id=452edaf8"
import script from "./ModalApprovalEmployeeOrders.vue?vue&type=script&lang=js"
export * from "./ModalApprovalEmployeeOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__